import { Link } from 'react-router-dom';
import { Gift } from 'lucide-react';
import { ROUTE_NAMES } from '@tsgecart/config';

/**
 * Premium gold pill promoting the "Earn with Fun" / rewards landing page
 * (`/earn-with-fun`) -- used in both the desktop nav (`site-header.tsx`)
 * and the mobile drawer (`mobile-menu.tsx`) so there is exactly one
 * implementation of the visual treatment to maintain. The float + glow
 * animations are `motion-safe:`-gated so `prefers-reduced-motion: reduce`
 * gets a static (but still fully functional) button.
 */
export interface EarnWithFunButtonProps {
  onClick?: () => void;
  className?: string;
  /** Drawer/full-width usage (mobile menu) -- always shows the full label
   * and stretches to the container width, instead of the compact
   * icon-first treatment used in the header's narrow nav slot. */
  fullWidth?: boolean;
}

export function EarnWithFunButton({ onClick, className = '', fullWidth = false }: EarnWithFunButtonProps) {
  return (
    <Link
      to={ROUTE_NAMES.earnWithFun}
      onClick={onClick}
      className={`focus-visible:ring-brand group text-brand-foreground inline-flex items-center gap-1.5 rounded-full bg-gradient-to-r from-brand to-brand-orange px-3 py-2 text-sm font-semibold shadow-sm transition hover:-translate-y-0.5 hover:shadow-lg focus-visible:outline-none focus-visible:ring-2 motion-safe:animate-float motion-safe:hover:animate-none sm:px-4 ${
        fullWidth ? 'w-full justify-center' : ''
      } ${className}`}
    >
      <span className="motion-safe:animate-glow-pulse flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-white/40">
        <Gift className="h-3.5 w-3.5" aria-hidden="true" />
      </span>
      <span className={fullWidth ? 'inline' : 'hidden sm:inline'}>Earn with Fun</span>
      {!fullWidth && <span className="sm:hidden">Earn</span>}
    </Link>
  );
}
